import React from "react";
import { ProtectedRoutes } from "./ProtectedRoutes";

export const AppRoutes = () => {
  return (
      <>
        <ProtectedRoutes />
      </>
  );
}
